<template>
  <div>
    <el-form :model="messageForm" label-width="130px" label-position="left" :rules="messageRules" ref="messageFormRef" class="message-form">
      <el-form-item :label="`${$t('mess.mess67')}：`">
        <span>{{ $t("mess.mess77") }}</span>
      </el-form-item>
      <el-form-item :label="`${$t('mess.mess21')}：`" prop="remindingTitle">
        <el-input v-model="messageForm.remindingTitle"></el-input>
      </el-form-item>
      <el-form-item :label="`${$t('mess.mess22')}：`" prop="remindingContent">
        <quill-editor ref="quillEditorRef" :options="editorOption" v-model="messageForm.remindingContent" />
      </el-form-item>
      <el-form-item label-width="0px">
        <el-col :span="11">
          <el-form-item :label="`${$t('mess.mess19')}：`" prop="orderId">
            <el-input v-model="messageForm.orderId"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11" :offset="2">
          <el-form-item :label="`${$t('mess.mess69')}：`" prop="containerBatchNo">
            <el-input v-model="messageForm.containerBatchNo"></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="`${$t('mess.mess45')}：`">
        <el-upload
          :http-request="handleUpload"
          action=""
          multiple
          :limit="9"
          :before-upload="beforeUploadFile"
          :on-exceed="handleExceed"
          :file-list="fileList"
          :show-file-list="false"
          accept=".xls,.xlsx,.pdf,.png,.jpg,.jpeg,.mp4,.ai,.gif,.xlsm"
        >
          <el-button class="search-btn btn-blue upload-btn">{{ $t("createOrder.createOrder20") }}</el-button>
        </el-upload>
        <div class="file-list-wrap">
          <div class="file-list-item" v-for="item in fileList" :key="item.url">
            <div class="img-wrap">
              <img v-if="['.xls', '.xlsx', '.xlsm'].includes(item.suffix)" src="@/assets/images/icon_excel.png" alt="" />
              <img v-else-if="item.suffix === '.pdf'" src="@/assets/images/icon_pdf.png" alt="" />
              <video
                v-else-if="item.suffix === '.mp4'"
                :src="item.url"
                :width="100"
                :height="100"
                controlsList="nodownload noplaybackrate"
                disablepictureinpicture
              ></video>
              <img v-else :src="item.url" alt="" />
              <div class="operation">
                <i v-if="!['.xls', '.xlsx', '.pdf', '.xlsm'].includes(item.suffix)" class="el-icon-circle-plus-outline" @click="handleReview(item)"></i>
                <i class="el-icon-delete" @click="handleRemove(item)"></i>
              </div>
            </div>
            <span class="text-hidden">{{ item.name }}</span>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <el-dialog title="" append-to-body :visible.sync="showPictureView" width="30%" show-close center close-on-click-modal @close="closeImgViewer">
      <video v-if="isVideo" :src="imgurl" width="100%" controls controlsList="nodownload noplaybackrate" disablepictureinpicture></video>
      <img v-else width="100%" height="auto" :src="imgurl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "MessageForm",
  props: {
    submitUrl: {
      type: String,
      default: false,
    },
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
    messageGroup: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      messageForm: {
        remindingTitle: "",
        remindingContent: "",
        orderNo: "",
        orderId: "",
        containerBatchNo: "",
      },
      fileList: [],
      messageRules: {
        remindingTitle: [{ required: true, message: this.$t("mess.mess29"), trigger: "blur" }],
        remindingContent: [{ required: true, message: this.$t("mess.mess30"), trigger: "blur" }],
        orderId: [{ require: false, pattern: /^[A-Za-z0-9]+$/, message: this.$t("mess.mess78"), trigger: "blur" }],
        containerBatchNo: [{ require: false, pattern: /^[A-Za-z0-9]+$/, message: this.$t("mess.mess78"), trigger: "blur" }],
      },
      editorOption: {
        modules: {
          clipboard: {
            matchers: [["img", this.handlePasteImg]],
          },
          toolbar: false,
        },
      },
      imgurl: "",
      showPictureView: false,
      isVideo: false,
    };
  },
  mounted() {
    this.username = sessionStorage.getItem("username");
    this.initMessageForm();
  },
  watch: {
    // "info.messageGroupId": function (val, old) {
    //   if (val !== old) {
    //     this.initMessageForm();
    //   }
    // },
    messageGroup: {
      handler: function () {
        this.initMessageForm();
      },
      deep: true,
    },
  },
  methods: {
    handlePasteImg(_, delta) {
      let ops = [];
      delta.ops.forEach(async (op) => {
        if (op.insert && typeof op.insert !== "string") {
          // 如果粘贴了图片，这里会是一个对象
          if (op.insert.image) {
            if (op.insert.image.includes(";base64")) {
              let file = this.dataURLtoFile(op.insert.image, `paste-${Math.random().toString(36).slice(-8)}.jpg`);
              let fileFormdata = new FormData();
              fileFormdata.append("file", file);
              this.$http.post("cmUser/message/uploadFile", fileFormdata).then(({ data: res }) => {
                if (res.code === 200) {
                  const { filePath } = res.data;
                  let quill = this.$refs.quillEditorRef.quill; // 获取富文本对象
                  let length = quill.getSelection().index; // 获取编辑器光标位置
                  quill.insertEmbed(length, "image", filePath); // 插入图片  图片地址
                  quill.setSelection(length + 1);
                }
              });
            }
          }
        }
      });
      delta.ops = ops; // 不加会报错
      return delta;
    },
    dataURLtoFile(dataurl, name) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], name, { type: mime });
    },
    initMessageForm() {
      this.messageForm.orderId = this.info.orderId;
      this.messageForm.containerBatchNo = this.info.containerBatchNo;
      this.messageForm.remindingTitle = this.info.remindingTitle ? `${this.$t("mess.mess15")}：${this.info.remindingTitle}` : "";
      // const replyArray =
      //   this.messageGroup.length && this.messageGroup.filter((item) => item.createUserName !== this.username && item.forwardType == 1);
      // if (replyArray && replyArray.length) {
      //   this.messageForm.remindingTitle = `${this.$t("mess.mess15")}：${replyArray[0].remindingTitle}`;
      // } else {
      //   this.messageForm.remindingTitle = "";
      // }
    },
    handleUpload(file) {
      let fileFormdata = new FormData();
      fileFormdata.append("file", file.file);
      this.$http.post("cmUser/message/uploadFile", fileFormdata).then(({ data: res }) => {
        if (res.code === 200) {
          const { fileName, filePath } = res.data;
          const suffix = file.file.name.substring(file.file.name.lastIndexOf(".")).toLowerCase();
          const obj = {
            name: file.file.name,
            url: filePath,
            suffix,
          };
          this.fileList.push(obj);
        }
      });
    },
    handleExceed() {
      const msg = this.$t("mess.mess72");
      this.$message.warning(msg);
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      if (index !== -1) {
        this.fileList.splice(index, 1);
      }
    },
    beforeUploadFile(file) {
      const applyTypeArray = [".xls", ".xlsx", ".pdf", ".png", ".jpg", ".jpeg", ".mp4", ".ai", ".gif", ".xlsm"];
      const extension = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      // const size = file.size / 1024 / 1024
      if (!applyTypeArray.includes(extension.toLowerCase())) {
        const message = this.$t("mess.mess73");
        this.$message.warning(message);
        return false;
      }
      // if (size > 10) {
      //   this.$message.warning('文件大小不得超过10M')
      // }
    },
    formReset() {
      this.$refs.messageFormRef.resetFields();
      this.initMessageForm();
      this.fileList = [];
    },
    submit() {
      this.$refs.messageFormRef.validate((valid) => {
        if (!valid) {
          // this.$message.error(this.$t("mess.mess37"));
          return false;
        }
        this.querySend();
      });
    },
    querySend() {
      const { messageGroupId } = this.info;
      const fileModels = this.fileList.map((item) => {
        return {
          fileName: item.name,
          filePath: item.url,
        };
      });
      let params = {
        ...this.messageForm,
        fileModels,
        messageGroupId,
      };
      if (this.submitUrl === "cmUser/message2/reply") {
        params.orderId = this.messageForm.orderId;
        const replyArray = this.messageGroup.length && this.messageGroup.filter((item) => item.forwardType == 1 && item.remindingUserName !== "all");
        if (replyArray.length) {
          params.remindingUserId = replyArray[0].createUserId;
          params.remindingUserName = replyArray[0].createUserName;
        } else {
          const remindUserInfo = this.messageGroup.filter((item) => item.createUserName === this.username);
          // console.log(this.messageGroup,99999)
          // console.log(this.info,99999)
          // console.log(remindUserInfo,99999)
          if(remindUserInfo.length > 0) {
            params.remindingUserId = remindUserInfo[0].remindingUserId;
            params.remindingUserName = remindUserInfo[0].remindingUserName;
          }else {
            params.remindingUserId =  sessionStorage.getItem("userId");
            params.remindingUserName = this.username
          }

        }
      }
      this.$http
        .post(this.submitUrl, params)
        .then(({ data: res }) => {
          if (res.code === 200) {
            this.$message.success(this.$t("mess.mess74"));
            this.$emit("refreshData");
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {
          this.$message.error(this.$t("prompt.failed"));
        });
    },
    closeImgViewer() {
      this.showPictureView = false;
    },
    handleReview(item) {
      if (item.suffix === ".mp4") {
        this.isVideo = true;
      } else {
        this.isVideo = false;
      }
      this.imgurl = item.url;
      this.showPictureView = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.message-form {
  border-bottom: 3px solid #ccc;
  ::v-deep .ql-container {
    height: 150px;
  }
  ::v-deep .ql-editor {
    min-height: 0;
    overflow: auto;
  }
}
.upload-btn {
  padding: 9px 40px !important;
}
.file-list-wrap {
  display: flex;
  margin-top: 10px;
  gap: 10px;
  flex-wrap: wrap;
  .file-list-item {
    width: 100px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    .img-wrap {
      width: 100px;
      height: 100px;
      border: 1px solid #ccc;
      border-radius: 10px;
      overflow: hidden;
      position: relative;
      img {
        height: 100%;
      }
      .operation {
        cursor: pointer;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
        transition: opacity 0.3s;
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;
        font-size: 18px;
        display: flex;
        justify-content: center;
        gap: 20px;
        align-items: center;
        &:hover {
          opacity: 1;
        }
      }
    }
    .text-hidden {
      margin-top: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 18px;
      text-align: center;
    }
  }
}
</style>
